/**
 * Resultado da cópia, no próprio botão, por um instante. A notificação do app aparece na guia, que não se
 * vê quando a sala está na janela flutuante: o botão precisa confirmar (ou avisar que falhou) sozinho.
 *
 * `copy(...args)` chama `onCopy` e espera o resultado: `false` é falha; qualquer outra coisa (inclusive
 * `undefined`, de quem não devolve nada) é sucesso.
 * @param {(...args: any[]) => unknown} onCopy
 * @returns {['idle' | 'copied' | 'failed', (...args: any[]) => Promise<void>]}
 */
import { useCallback, useEffect, useRef, useState } from 'react';

export const COPY_FEEDBACK_MS = 2000;

export function useCopyFeedback(onCopy, ms = COPY_FEEDBACK_MS) {
    const [status, setStatus] = useState('idle');
    const mounted = useRef(true);
    useEffect(() => () => { mounted.current = false; }, []);

    useEffect(() => {
        if (status === 'idle') return undefined;
        const timer = setTimeout(() => setStatus('idle'), ms);
        return () => clearTimeout(timer);
    }, [status, ms]);

    const copy = useCallback(async (...args) => {
        let ok;
        try {
            ok = await onCopy(...args);
        } catch {
            ok = false;
        }
        if (mounted.current) setStatus(ok === false ? 'failed' : 'copied');
    }, [onCopy]);

    return [status, copy];
}
